var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { on: { click: _vm.openDetails } },
    [
      _vm.travelServiceOrderItem.type === "car"
        ? _c("travel-service-order-item-car-chip", {
            staticClass: "travel-service-chips",
            attrs: {
              "travel-service-order-item": _vm.travelServiceOrderItem,
              textColor: _vm.textColor,
              color: _vm.color,
              text: _vm.text
            }
          })
        : _vm.travelServiceOrderItem.type === "hotel"
        ? _c("travel-service-order-item-hotel-chip", {
            staticClass: "travel-service-chips",
            attrs: {
              "travel-service-order-item": _vm.travelServiceOrderItem,
              textColor: _vm.textColor,
              color: _vm.color,
              text: _vm.text
            }
          })
        : _vm.travelServiceOrderItem.type === "insurance"
        ? _c("travel-service-order-item-insurance-chip", {
            staticClass: "travel-service-chips",
            attrs: {
              "travel-service-order-item": _vm.travelServiceOrderItem,
              "text-color": _vm.textColor,
              color: _vm.color,
              text: _vm.text
            }
          })
        : _vm.travelServiceOrderItem.type === "flight"
        ? _c("travel-service-order-item-flight-chip", {
            staticClass: "travel-service-chips",
            attrs: {
              "travel-service-order-item": _vm.travelServiceOrderItem,
              textColor: _vm.textColor,
              color: _vm.color,
              text: _vm.text
            }
          })
        : _vm.travelServiceOrderItem.type === "rail"
        ? _c("travel-service-order-item-rail-chip", {
            staticClass: "travel-service-chips",
            attrs: {
              "travel-service-order-item": _vm.travelServiceOrderItem,
              textColor: _vm.textColor,
              color: _vm.color,
              text: _vm.text
            }
          })
        : _c("travel-service-order-item-other-chip", {
            staticClass: "travel-service-chips",
            attrs: {
              "travel-service-order-item": _vm.travelServiceOrderItem,
              textColor: _vm.textColor,
              color: _vm.color,
              text: _vm.text
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }